import React from 'react';
import { Modal } from 'react-bootstrap';

import { Form } from '../utils/inputs';

interface Props {
    onSubmit: () => Promise<any>;
    onClose: () => void;

    title: string;
    confirmTitle: string;
    description: string;
}

const ConfirmModalReset = ({ onClose, title, confirmTitle, description, onSubmit }: Props) => {
    const handleSubmit = async (event) => {
        event.preventDefault();
        await onSubmit();
    };

    return (
        <Modal backdrop="static" centered keyboard={false} onHide={onClose} show>
            <Modal.Header>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Form className="mv1 wfp-form" onSubmit={handleSubmit}>
                <Modal.Body>
                    <div>
                        <div className="form-group">
                            <p>{description}</p>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="wfp-btn" onClick={onClose} style={{ marginRight: 10 }} type="button">
                        No
                    </button>
                    <button className="wfp-btn--primary" type="submit">
                        {confirmTitle}
                    </button>
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

export default ConfirmModalReset;
